import { SilentSignin } from './modules/auth/components/silentSignin';
// import { StatisticsContextProvider } from './shared/contexts/statisticsContext';
import { dayjsSetup } from './shared/functions/dayjsSetup';
import { Routes } from './shared/routes/routes';

export const App = () => {
  dayjsSetup(); // Setup dayjs with language settings, TODO

  return (
    <>
      <SilentSignin />
      <Routes />
    </>
  );
};
